import { useCallback, useEffect, useState } from 'react';

/**
 * Captures beforeinstallprompt so the avatar menu can offer "Instalar app".
 * Returns { canInstall, promptInstall }.
 */
export function usePwaInstall({
  addListener = (type, handler) => {
    if (typeof window === 'undefined') return () => {};
    window.addEventListener(type, handler);
    return () => window.removeEventListener(type, handler);
  },
} = {}) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const onBeforeInstall = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    const onInstalled = () => setDeferredPrompt(null);
    const removeBefore = addListener('beforeinstallprompt', onBeforeInstall);
    const removeInstalled = addListener('appinstalled', onInstalled);
    return () => {
      removeBefore();
      removeInstalled();
    };
  }, [addListener]);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) return { outcome: 'unavailable' };
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    return choice;
  }, [deferredPrompt]);

  return {
    canInstall: Boolean(deferredPrompt),
    promptInstall,
  };
}
